module.exports = __webpack_public_path__ + "images/king-of-the-hill-6650f38f3819c430b2eb3981cca03b7f.png";